module.exports = __webpack_public_path__ + "img/circle-filled.9a18a459.png";